module.exports = function() {
  return new Worker("/" + "unzip_imgs.worker.b61527fa836229095a06.js");
};